import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import Riders from './Riders';
import Drivers from './Drivers';
import FleetAdmins from './FleetAdmins';
import CreateAdmin from './CreateAdmin';
import UserCreateDialog from '../components/UserCreateDialog';
import UserBulkImportDialog from '../components/UserBulkImportDialog';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import { useTranslation } from "react-i18next";

import { useSelector } from "react-redux";
import { PageHeader } from '../common/tableTheme';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function Users() {
  const [value, setValue] = React.useState(0);
  const [createDialogOpen, setCreateDialogOpen] = React.useState(false);
  const [bulkOpen, setBulkOpen] = React.useState(false);
  const { t } = useTranslation();

  const auth = useSelector(state => state.auth);
  const isSuperAdmin = Boolean(
    auth?.profile?.is_superadmin ||
    auth?.profile?.role === 'superadmin' ||
    auth?.profile?.usertype === 'superadmin'
  );

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const getRoleForActiveTab = () => {
    if (isSuperAdmin) {
      if (value === 0) return 'fleetadmin';
      if (value === 1) return 'admin';
      if (value === 2) return 'driver';
      return 'customer';
    }
    return value === 0 ? 'driver' : 'customer';
  };

  return (
    <Box sx={{ width: '100%', p: 0.5 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 2, mb: 1 }}>
        <PageHeader 
          title={isSuperAdmin ? "Gestão de Usuários & Equipes" : "Motoristas & Equipe"} 
          subtitle={
            isSuperAdmin 
              ? "Administração de gestores, administradores, condutores e solicitantes de todos os tenants."
              : "Gestão de condutores operacionais e contatos da frota."
          }
        />
        <Button
          variant="outlined"
          startIcon={<UploadFileIcon />}
          onClick={() => setBulkOpen(true)}
          sx={{
            fontWeight: 600,
            fontSize: '0.85rem',
            px: 2,
            py: 1,
            borderRadius: '10px',
            textTransform: 'none',
            borderColor: '#0f172a',
            color: '#0f172a',
            '&:hover': { borderColor: '#0f172a', bgcolor: '#f1f5f9' }
          }}
        >
          Importar em Lote
        </Button>
        <Button
          variant="contained"
          startIcon={<PersonAddAlt1Icon />}
          onClick={() => setCreateDialogOpen(true)}
          sx={{
            bgcolor: '#0f172a',
            color: '#ffffff',
            fontWeight: 700,
            fontSize: '0.85rem',
            px: 2.5,
            py: 1,
            borderRadius: '10px',
            textTransform: 'none',
            boxShadow: '0 4px 6px -1px rgba(15, 23, 42, 0.15)',
            '&:hover': {
              bgcolor: '#1e293b',
            }
          }}
        >
          {isSuperAdmin ? "+ Novo Usuário / Gestor" : "+ Novo Usuário / Motorista"}
        </Button>
      </Box>

      <Box sx={{ 
        bgcolor: '#f1f5f9', 
        p: 0.5, 
        borderRadius: '12px', 
        display: 'inline-flex',
        border: '1px solid #e2e8f0',
        mb: 2.5
      }}>
        <Tabs 
          value={value} 
          onChange={handleChange} 
          TabIndicatorProps={{ style: { display: 'none' } }}
          sx={{
            minHeight: '36px',
            '& .MuiTab-root': {
              minHeight: '36px',
              py: 0.75,
              px: 2,
              borderRadius: '8px',
              fontSize: '0.8125rem',
              fontWeight: 600,
              textTransform: 'none',
              color: '#64748b',
              transition: 'all 0.15s ease',
              '&.Mui-selected': {
                color: '#ffffff',
                bgcolor: '#0f172a',
                boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
              }
            }
          }}
        >
          {isSuperAdmin ? (
            [
              <Tab key="fleetadmins" label="Gestores de Frota" {...a11yProps(0)} />,
              <Tab key="admins" label="Administradores" {...a11yProps(1)} />,
              <Tab key="drivers" label="Condutores / Motoristas" {...a11yProps(2)} />,
              <Tab key="riders" label="Solicitantes / Contatos" {...a11yProps(3)} />
            ]
          ) : (
            [
              <Tab key="drivers" label="Condutores / Motoristas" {...a11yProps(0)} />,
              <Tab key="riders" label="Solicitantes / Contatos" {...a11yProps(1)} />
            ]
          )}
        </Tabs>
      </Box>

      {/* Conteúdo das Abas */}
      {isSuperAdmin ? (
        <>
          <TabPanel value={value} index={0}>
            <FleetAdmins/>
          </TabPanel>
          <TabPanel value={value} index={1}>
            <CreateAdmin/>
          </TabPanel>
          <TabPanel value={value} index={2}>
            <Drivers/>
          </TabPanel>
          <TabPanel value={value} index={3}>
            <Riders/>
          </TabPanel>
        </>
      ) : (
        <>
          <TabPanel value={value} index={0}>
            <Drivers/>
          </TabPanel>
          <TabPanel value={value} index={1}>
            <Riders/>
          </TabPanel>
        </>
      )}

      {/* Diálogo Unificado de Cadastro com Supabase Auth */}
      <UserCreateDialog
        open={createDialogOpen}
        onClose={() => setCreateDialogOpen(false)}
        defaultRole={getRoleForActiveTab()}
      />
      <UserBulkImportDialog
        open={bulkOpen}
        onClose={() => setBulkOpen(false)}
        defaultRole={getRoleForActiveTab()}
      />
    </Box>
  );
}